// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.5
  ); /* Warna hitam dengan transparansi 50% */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-box {
  position: relative;
  background-color: #fff;
  padding: 20px;
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); */
}

.popup-actions button {
  padding: 5rem;
}

.close-button {
  position: absolute;
  top: 0;
  right: 10px;
  background: none;
  border: none;
  font-size: 25px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
}

.close-button:hover {
  color: #ff0000; /* Warna merah saat di-hover */
}

.pop-up-box-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
}

.pop-up-box-content h2 {
  font-size: 2rem;
  color: #2c3e50;
}

.pop-up-box-content form {
  padding: 1rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-top: 5px solid #008000;
}

.pop-up-box-content form input {
  font-size: 1rem;
  padding: 5px 0px 5px 10px;
  border: 1px solid #2c3e50;
  border-radius: 10px;
}

.popup-actions {
  display: flex;
  justify-content: center;
}

.popup-actions .popupSubmit {
  padding: 10px 15px;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-weight: 500;
  background-color: #2c3e50;
  color: #fff;
}

.popup-actions .popupSubmit:hover {
  filter: brightness(1.1);
}

input::placeholder {
  color: #999;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pop-up-box.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC,EAAE,wCAAwC;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ","sourcesContent":[".popup-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(\r\n    0,\r\n    0,\r\n    0,\r\n    0.5\r\n  ); /* Warna hitam dengan transparansi 50% */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.popup-box {\r\n  position: relative;\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2); */\r\n}\r\n\r\n.popup-actions button {\r\n  padding: 5rem;\r\n}\r\n\r\n.close-button {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n  color: #333;\r\n  cursor: pointer;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #ff0000; /* Warna merah saat di-hover */\r\n}\r\n\r\n.pop-up-box-content {\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pop-up-box-content h2 {\r\n  font-size: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.pop-up-box-content form {\r\n  padding: 1rem 1rem 2rem 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  font-size: 1.1rem;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\r\n  border-top: 5px solid #008000;\r\n}\r\n\r\n.pop-up-box-content form input {\r\n  font-size: 1rem;\r\n  padding: 5px 0px 5px 10px;\r\n  border: 1px solid #2c3e50;\r\n  border-radius: 10px;\r\n}\r\n\r\n.popup-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.popup-actions .popupSubmit {\r\n  padding: 10px 15px;\r\n  border: none;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  background-color: #2c3e50;\r\n  color: #fff;\r\n}\r\n\r\n.popup-actions .popupSubmit:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\ninput::placeholder {\r\n  color: #999;\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
